// ConfirmDialogComponent.jsx
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material';

export default function ConfirmDialogComponent({
  open,
  title = "Confirmation",
  content = "Are you sure you want to proceed?",
  onConfirm,
  onCancel,
  confirmLabel = "Yes",
  cancelLabel = "Cancel",
  loading = false,
  loadingConfirmLabel, // Optional custom label while loading
}) {
  return (
    <Dialog open={open} onClose={onCancel} fullWidth maxWidth="xs">
      <DialogTitle id="alert-dialog-title">
          {title}
      </DialogTitle>
      <DialogContent>{content}</DialogContent>
      <DialogActions>
        <Button onClick={onCancel} disabled={loading}>
          {cancelLabel}
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          color="error"
          disabled={loading}
        >
          {loading ? (loadingConfirmLabel || confirmLabel) : confirmLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
